export default "/v8.61.0/9a1d26a/bundles/opensearch.xml";